module.exports = __webpack_public_path__ + "img/logo-eng.e0a917ff.png";